export function arraysMatch(arr1, arr2) {
  const indices1 = arr1
    .map((value, index) => (value === 1 ? index : -1))
    .filter((index) => index !== -1);
  const indices2 = arr2
    .map((value, index) => (value === 1 ? index : -1))
    .filter((index) => index !== -1);
  return (
    indices1.length === indices2.length &&
    indices1.every((index) => indices2.includes(index))
  );
}
